import React from 'react';
import G6Editor from '@antv/g6-editor';
import './style.less';

class ItemPanel extends React.Component {
    createItempanel(container) {
        return new G6Editor.Itempannel({
            container
        });
    }

    getCreateItempanel() {
        const { createItempanel } = this.props;
        return createItempanel ? createItempanel : this.createItempanel;
    }

    componentDidMount() {
        const { editor } = this.props;
        const createItempanel = this.getCreateItempanel();
        const itempanel = createItempanel(this.itempanelContainer);
        editor.add(itempanel);
    }

    render() {
        return (
            <div className="itempanel" ref={el => { this.itempanelContainer = el; }}>
                {this.props.content}
            </div>
        );
    }
}

export default ItemPanel;


// WEBPACK FOOTER //
// ./src/components/common/flowChart/ItemPanel.js